module.exports = __webpack_public_path__ + "static/img/four.b2f7049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/4/four.png
// module id = Edk+
// module chunks = 1